<app-btn-nuevo-propiedad *appRole="['Propiedades.Crear']"></app-btn-nuevo-propiedad>
<br>
<br>
<mat-card *appRole="['Propiedades.Ver']">
  <form [formGroup]="form">
    <div class="row">
      <div class="col-lg-2">
        <mat-form-field class="example-full-width">
          <ngx-spinner [zIndex]="100" name="spBusquedaEstadosPropiedad" bdColor="rgba(255,255,255,0.8)" size="small"
            color="#009688" type="line-scale" [fullScreen]="false"></ngx-spinner>
          <mat-label>Estado propiedad</mat-label>
          <mat-select placeholder="Seleccione opción" multiple formControlName="EstadosPropiedad">
            <mat-option [value]="item.id" *ngFor="let item of lstEstadosContrato; trackBy: trackByItems">
              {{ item.descripcion | titlecase }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-lg-2">
        <mat-form-field class="example-full-width">
          <ngx-spinner [zIndex]="100" name="spBusquedaTiposPropiedad" bdColor="rgba(255,255,255,0.8)" size="small"
            color="#009688" type="line-scale" [fullScreen]="false"></ngx-spinner>
          <mat-label>Tipos propiedad</mat-label>
          <mat-select placeholder="Seleccione opción" multiple formControlName="TiposPropiedad">
            <mat-option [value]="item.id" *ngFor="let item of lstTiposPropiedad; trackBy: trackByItems">
              {{ item.descripcion | titlecase }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-lg-2">
        <mat-form-field class="example-full-width">
          <ngx-spinner [zIndex]="100" name="spBusquedaPropiedadClase" bdColor="rgba(255,255,255,0.8)" size="small"
            color="#009688" type="line-scale" [fullScreen]="false"></ngx-spinner>
          <mat-label>Clase propiedad</mat-label>
          <mat-select placeholder="Seleccione opción" multiple formControlName="ClasesPropiedad">
            <mat-option [value]="item.id" *ngFor="let item of lstPropiedadClase; trackBy: trackByItems">
              {{ item.descripcion | titlecase }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-lg-3">
        <mat-form-field class="full-width">
          <mat-label>Fecha creación</mat-label>
          <mat-date-range-input [rangePicker]="picker">
            <input matStartDate [disabled]="true" formControlName="FechaAltaDesde" placeholder="Fecha desde">
            <input matEndDate [disabled]="true" formControlName="FechaAltaHasta" placeholder="Fecha hasta">
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker disabled="false"></mat-date-range-picker>
        </mat-form-field>
      </div>
      <div class="col-lg-1 d-flex align-items-center">
        <mat-checkbox formControlName="Activo">Activo</mat-checkbox>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-2">
        <button mat-stroked-button color="primary" (click)="filtrarPropiedades()">
          <mat-icon>filter_alt</mat-icon>
          Filtrar
        </button>
      </div>
    </div>
  </form>

  <ngx-spinner name="spListadoPropiedad" bdColor="rgba(255,255,255,0.8)" size="default" color="#009688" type="ball-atom"
    [fullScreen]="false">
  </ngx-spinner>
  <div class="row" *ngIf="dataSource.data.length >= 1">
    <div class="col-lg-2">
      <mat-form-field>
        <input matInput class="form-field" [formControl]="ubicacionFilter" placeholder="Filtro Ubicación">
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>
    </div>
    <div class="col-lg-2">
      <mat-form-field>
        <input matInput class="form-field" [formControl]="localidadFilter" placeholder="Filtro Localidad">
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>
    </div>
  </div>

  <div class="tabla-container">
    <table mat-table [dataSource]="dataSource" [hidden]=!data matSort matSortStart="asc" class="mat-elevation-z8"
      full-width>

      <!-- Columna Ubicación -->
      <ng-container matColumnDef="ubicacion">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="header-cell">
          <mat-icon class="header-icon">place</mat-icon>
          Ubicación
        </mat-header-cell>
        <mat-cell *matCellDef="let propiedad" class="ubicacion-cell">
          <div class="ubicacion-info">
            <div class="direccion-principal" *ngIf="propiedad.ubicacion; else sinUbicacion">
              <strong>{{ propiedad.ubicacion | uppercase }}</strong>
              <span *ngIf="propiedad.piso" class="detalle-ubicacion">
                Piso: {{ propiedad.piso | uppercase }}
              </span>
              <span *ngIf="propiedad.departamento" class="detalle-ubicacion">
                Depto: {{ propiedad.departamento | uppercase }}
              </span>
            </div>
            <ng-template #sinUbicacion>
              <span class="sin-datos">
                <mat-icon>location_off</mat-icon>
                Sin ubicación
              </span>
            </ng-template>
          </div>
        </mat-cell>
      </ng-container>

      <!-- Columna Propietario -->
      <ng-container matColumnDef="propietario">
        <mat-header-cell *matHeaderCellDef class="header-cell">
          <mat-icon class="header-icon">people</mat-icon>
          Propietarios
        </mat-header-cell>
        <mat-cell *matCellDef="let propiedad" class="propietarios-cell">
          <div class="propietarios-container" *ngIf="propiedad?.propietario?.length > 0; else noPropietarios">
            <mat-chip-list class="propietarios-chips">
              <mat-chip *ngFor="let prop of propiedad.propietario;" class="propietario-chip" color="primary" selected>
                <mat-icon matChipAvatar>person</mat-icon>
                {{ prop.descripcion | titlecase }}
              </mat-chip>
            </mat-chip-list>
          </div>
          <ng-template #noPropietarios>
            <div class="sin-datos">
              <mat-icon>person_off</mat-icon>
              Sin propietarios
            </div>
          </ng-template>
        </mat-cell>
      </ng-container>

      <!-- Columna Localidad -->
      <ng-container matColumnDef="localidad">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="header-cell">
          <mat-icon class="header-icon">location_city</mat-icon>
          Localidad
        </mat-header-cell>
        <mat-cell *matCellDef="let propiedad">
          <span *ngIf="propiedad.localidad?.descripcion; else sinLocalidad">
            {{ propiedad.localidad.descripcion | titlecase }}
          </span>
          <ng-template #sinLocalidad>
            <span class="sin-datos">Sin localidad</span>
          </ng-template>
        </mat-cell>
      </ng-container>

      <!-- Columna Tipo Propiedad -->
      <ng-container matColumnDef="tipoPropiedad">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="header-cell">
          <mat-icon class="header-icon">category</mat-icon>
          Tipo
        </mat-header-cell>
        <mat-cell *matCellDef="let propiedad">
          <span *ngIf="propiedad.tipoPropiedad?.descripcion; else sinTipo">
            {{ propiedad.tipoPropiedad.descripcion | titlecase }}
          </span>
          <ng-template #sinTipo>
            <span class="sin-datos">Sin tipo</span>
          </ng-template>
        </mat-cell>
      </ng-container>

      <!-- Columna Clase Propiedad -->
      <ng-container matColumnDef="propiedadClase">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="header-cell">
          <mat-icon class="header-icon">class</mat-icon>
          Clase
        </mat-header-cell>
        <mat-cell *matCellDef="let propiedad">
          <span *ngIf="propiedad.propiedadClase?.descripcion; else sinClase">
            {{ propiedad.propiedadClase.descripcion | titlecase }}
          </span>
          <ng-template #sinClase>
            <span class="sin-datos">Sin clase</span>
          </ng-template>
        </mat-cell>
      </ng-container>

      <!-- Columna Estado -->
      <ng-container matColumnDef="estadoPropiedad">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="header-cell">
          <mat-icon class="header-icon">info</mat-icon>
          Estado
        </mat-header-cell>
        <mat-cell *matCellDef="let propiedad">
          <span class="estado-badge" [ngClass]="{
                    'estado-con-contrato': propiedad.estadoPropiedad.id === estadosPropiedadEnum.ConContrato,
                    'estado-sin-contrato': propiedad.estadoPropiedad.id === estadosPropiedadEnum.SinContrato
                  }">
            {{ propiedad.estadoPropiedad?.descripcion || 'Sin estado' }}
          </span>
        </mat-cell>
      </ng-container>

      <!-- Columna Fecha Alta -->
      <ng-container matColumnDef="fechaAlta">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="header-cell">
          <mat-icon class="header-icon">date_range</mat-icon>
          Fecha Alta
        </mat-header-cell>
        <mat-cell *matCellDef="let propiedad">
          <span class="fecha-badge">{{ propiedad.fechaAlta | date:'dd/MM/yyyy' }}</span>
        </mat-cell>
      </ng-container>

      <!-- Columna Activo -->
      <ng-container matColumnDef="activo">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="header-cell">
          <mat-icon class="header-icon">toggle_on</mat-icon>
          Activo
        </mat-header-cell>
        <mat-cell *matCellDef="let propiedad">
          <span class="activo-badge" [ngClass]="{
                    'activo-si': propiedad.activo,
                    'activo-no': !propiedad.activo
                  }">
            <mat-icon>{{ propiedad.activo ? 'check_circle' : 'cancel' }}</mat-icon>
            {{ propiedad.activo ? 'Sí' : 'No' }}
          </span>
        </mat-cell>
      </ng-container>

      <!-- Columna Acciones -->
      <ng-container matColumnDef="accion">
        <mat-header-cell *matHeaderCellDef class="header-cell">
          <mat-icon class="header-icon">settings</mat-icon>
          Acciones
        </mat-header-cell>
        <mat-cell *matCellDef="let propiedad" class="acciones-cell">
          <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Menú de acciones" class="menu-button">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button *appRole="['Propiedades.Modificar']" mat-menu-item [routerLink]="['/propiedades/' + propiedad.id]">
              <mat-icon color="primary">edit</mat-icon>
              <span>Editar</span>
            </button>
            <button *appRole="['Propiedades.Eliminar']" mat-menu-item (click)="openDialog('Eliminar', propiedad)">
              <mat-icon color="warn">delete</mat-icon>
              <span>Eliminar</span>
            </button>
          </mat-menu>
        </mat-cell>
      </ng-container>

      <!-- Definición de filas -->
      <mat-header-row *matHeaderRowDef="displayedColumns" class="tabla-header"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;" class="tabla-row" matRipple></mat-row>
    </table>

    <div class="no-data-table">
      <span class="with-icon" *ngIf="dataSource.data.length == 0"><mat-icon>search_off</mat-icon>No se encontraron datos
        para mostrar.</span>
    </div>
    <mat-paginator showFirstLastButtons [pageSize]="20" [hidden]=!data [pageSizeOptions]="[5, 10, 20,50,100,200]">
    </mat-paginator>
  </div>
</mat-card>
